import { PackageId } from '../web-shared/types/billing';

export interface Episode {
  description?: string;
  episodeNum?: number;
  iconic: string;
  id: string;
  seasonNum: number;
  title: string;
  startsAt?: string;
  originalAirDate?: string;
}

export type SeasonImage = {
  url: string;
  height: number;
  width: number;
  alt: string;
};

export interface Season {
  seasonNum: number;
  image: SeasonImage | null;
}

export interface Playable extends Episode {
  endsAt?: string;
  isLive?: boolean;
  show?: Show;
}

export interface FilteredUpcomingTile extends Playable {
  startsAt: string;
}

export interface Channel {
  broadcasts?: Playable[];
  collections?: Record<string, Show[]>;
  displayName: string;
  addOnId?: PackageId;
  id: string;
  logo: string;
  logoColor: string;
  logoWhite: string;
  vods?: Playable[];
}

export interface Show {
  cast?: string[];
  channel: Channel;
  description?: string;
  directors?: string[];
  genres?: string[];
  iconic: string;
  id: string;
  latestSeasonFinaleDate?: string;
  latestSeasonNum?: number;
  latestSeasonPremiereDate?: string;
  liveAsset?: Playable;
  moviePoster?: string;
  moviePosterIconic?: string;
  originalAirDate?: string;
  posterIconic?: string;
  ratings?: Array<{
    classification: string;
    value: string;
  }>;
  releaseYear?: string;
  runTimeHours?: string;
  runTimeMinutes?: string;
  thumb: string;
  title: string;
  upcoming: Episode[];
  vod: Episode[];
}

export interface PlayerAsset {
  assetId: string;
  assetType: string;
}

export enum LaunchType {
  CHANNEL = 'channel',
  COLLECTION = 'collection',
  EPISODE = 'episode',
  PROMO = 'promo',
  SHOW = 'show',
  SEASON = 'season',
}

export enum Flags {
  LIVE = 'live',
  VOD = 'vod',
}

export enum ImageWidths {
  CAROUSEL_TV = 960,
  HEADER = 1440,
  LOGO_M = 200,
  LOGO_S = 100,
  TILE = 320,
  TILE_PLACEHOLDER = 10,
  TV = 600,
}

export const TileDimensions = {
  SHOW: {
    height: '9em',
    width: '16em',
  },
  PLAYABLE: {
    height: '10.3em',
    width: '16em',
  },
} as const;

export type SitelinksConfig = Record<string, string>;

export const Classifications = {
  RATING: ['VCHIP', 'MPAA'],
  ADVISORY: ['advisory', 'guideline'],
};

export enum ShowPageType {
  EPISODE = 'episode',
  EVENT = 'event',
  MOVIE = 'movie',
  SHOW = 'show',
}

export enum EpisodesType {
  CARD = 'card',
  CTA = 'card_cta',
  STATIC = 'static',
}

export enum AssetTag {
  ADD_ON = 'Add-On',
}
